<template>
  <div id="app">
    <!-- 引入 Header 组件 -->
    <HeaderComponent />
    <router-view></router-view>
    <!-- 引入 Footer 组件 -->
    <FooterComponent />
  </div>
</template>

<script>
import HeaderComponent from "./pages/Header.vue";
import FooterComponent from "./pages/Footer.vue";
import router from "./router.js";

export default {
  name: "App",
  components: {
    HeaderComponent,
    FooterComponent,
  },
  router,
};
</script>
<style>
/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1d3;
  border-radius: 2px;
  transition: all 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.custom-txt-sj {
  padding-left: 20px;
}
body {
  font-family: "黑体";
  color: black;
}
</style>
